import { JSEncrypt } from 'jsencrypt'
const publicKey =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC/Mb25GUcN6dpVK/0LybT9VIdqvNTTX2gQX/B7wlNMoqXjlVxAbea8CZBU6chpw0hCwHkQzL5YZLY3Q1wmGmGZna5QsbOf3QCoQt6j0y0LM9Vt57heobZ/lsnQ5qyp0CG9yyVQpKg9zFTXoocC08HWmKCabfQe7rkDOZ5gRBP9zQIDAQAB'

// 加密
export const encryptData = (plaintext) => {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  try {
    return encrypt.encrypt(plaintext)
  } catch (error) {
    console.error('Encryption error:', error)
    return plaintext
  }
}
